export default "__VITE_ASSET__CaJPp1B5__"